"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressService = void 0;
var _httpClientFactory = require("../api/httpClientFactory");
/**
 * @typedef {Object} Self
 * @property {() => Axios} getHttpClient 
 * @property {(newInstance: Axios) => void} setHttpClient
 * @property {} getCookieService
 */

var MIDDLEWARE_URL = process.env.MIDDLEWARE_BASE_URL;
var BASE_PATH = '/GlmAddress';

/**
 * 
 * @param {string} path 
 * @returns {string}
 */
var buildUrl = function buildUrl(path) {
  var pathWithSlash = !path.startsWith('/') ? "/".concat(path) : path;
  return MIDDLEWARE_URL + BASE_PATH + pathWithSlash;
};

/**
 * 
 * @param {Self} self
 * @param {string} postcode 
 * @returns 
 */
var _validatePostcode = function validatePostcode(self, postcode) {
  return self.getHttpClient().get(buildUrl("/Postcode/Validate/".concat(postcode)));
};

/**
 * 
 * @param {Self} self 
 * @param {string} postcode 
 */
var _getSuburbs = function getSuburbs(self, postcode) {
  return self.getHttpClient().get(buildUrl("/Suburb/".concat(postcode)));
};

/**
 * 
 * @param {Self} self 
 * @param {string} address 
 */
var _validateAddress = function validateAddress(self, address) {
  return self.getHttpClient().post(buildUrl('/Validate'), address);
};

/**
 * 
 * @param {Self} self 
 * @param {string} addressLine 
 * @returns 
 */
var searchAddress = function searchAddress(self, addressLine) {
  return self.getHttpClient().post(buildUrl('/Experian/Address/Search'));
};

/**
 * 
 * @returns 
 */
var getAddressService = exports.getAddressService = function getAddressService(_ref) {
  var apiKey = _ref.apiKey,
    clientId = _ref.clientId;
  return function (aHttpClient) {
    var httpClient = aHttpClient !== null && aHttpClient !== void 0 ? aHttpClient : _httpClientFactory.httpClientFactory.create({
      apiKey: apiKey,
      clientId: clientId,
      hasApiKey: true
    });
    /** @type {Self} */
    var self = {
      getHttpClient: function getHttpClient() {
        return httpClient;
      }
    };
    return {
      /**
       * @param {string} postcode 
       */
      validatePostcode: function validatePostcode(postcode) {
        return _validatePostcode(self, postcode);
      },
      /**
       * @param {string} postcode 
       */
      getSuburbs: function getSuburbs(postcode) {
        return _getSuburbs(self, postcode);
      },
      /**
       * @param {string} address
       */
      validateAddress: function validateAddress(address) {
        return _validateAddress(self, address);
      },
      /**
       * @param {string} addressLine
       */
      searchForAddress: function searchForAddress(addressLine) {
        return searchAddress(self, addressLine);
      }
    };
  };
};